module.exports = "https://cdn.prod.zoopla.co.uk/_next/static/images/remortgage-bar-b32813e2ee9ed40275f7011d281e30e6.png";